export const ExtraDocumentConfigurationColsImport = () => {
    return [
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'documentNbr',
        id: 'documentNbr-col',
        fieldHeader: 'Original ETS Number',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'cblNbr',
        id: 'cblNumber-col',
        fieldHeader: 'CBL Number',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'equipmentNbr',
        id: 'equipmentNbr-col',
        fieldHeader: 'Container Number',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'EstimatedTimeOfArrival',
        id: 'eta-col',
        fieldHeader: 'ETA',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'EstimatedTimeOfDeparture',
        id: 'etd-col',
        fieldHeader: 'ETD',
        sortable: true
    }];
}

export const ExtraDocumentConfigurationColsExport = () => {
    return [
    
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'documentNbr',
        id: 'cblNumber-col',
        fieldHeader: 'Original Document Number',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'equipmentNbr',
        id: 'equipmentNbr-col',
        fieldHeader: 'Container Number',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'EstimatedTimeOfDeparture',
        id: 'etd-col',
        fieldHeader: 'ETD',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'EstimatedTimeOfArrival',
        id: 'eta-col',
        fieldHeader: 'ETA',
        sortable: true
    }];
}